import React from 'react';
import classnames from 'classnames';
import { Card } from '@andes/card';
import { Image } from 'frontend-image';
import { getImageVariation } from '@mshops-components-library/common';
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
var BACKGROUND_BLEND_MODE = {
  NORMAL: 'normal',
  OVERLAY: 'overlay',
  EMPTY: ''
};
var BannerWrapper = function BannerWrapper(_ref) {
  var className = _ref.className,
    link = _ref.link,
    children = _ref.children;
  if (!(link !== null && link !== void 0 && link.url)) {
    return /*#__PURE__*/_createRawReactElement("div", {
      className: className
    }, void 0, children);
  }
  return /*#__PURE__*/_createRawReactElement("a", {
    className: className,
    href: link.url,
    rel: link.rel,
    target: link.target
  }, void 0, children);
};
BannerWrapper.defaultProps = {
  className: '',
  link: {},
  children: null
};
var BannerWrapper$1 = BannerWrapper;
var ASPECT_RATIOS_BY_SIZE = {
  mobile: {
    large: (16 / 9).toFixed(2),
    small: (3 / 1).toFixed(2)
  },
  desktop: {
    large: (4 / 1).toFixed(2),
    small: (6 / 1).toFixed(2)
  }
};
var MAX_IMAGE_SIZE_BY_DEVICE = {
  DESKTOP: 1200,
  MOBILE: 500
};
var validateAndConvertImageUrl = function validateAndConvertImageUrl(url, requiredSize) {
  var appearanceApiImageRegex = /^https:\/\/http2\.mlstatic\.com\/storage\/mshops-appearance-api\/resources\/default\/(toys|tools|sports|simple|material|legend|home_deco|fashion|explorer|electronics)\/[a-zA-Z0-9]+\.(png|jpg)$/;
  if (appearanceApiImageRegex.test(url)) {
    return url === null || url === void 0 ? void 0 : url.replace(/\.(png|jpg)$/, '.webp');
  }
  return getImageVariation(requiredSize, url);
};
const SecondaryBanner = /*#__PURE__*/function () {
  const SecondaryBanner = function SecondaryBanner(_ref) {
    var link = _ref.link,
      _ref$styles = _ref.styles,
      bgColor = _ref$styles.bg_color,
      bgMobile = _ref$styles.bg_mobile,
      bgDesktop = _ref$styles.bg_desktop,
      backgroundPosition = _ref$styles.align,
      backgroundBlendMode = _ref$styles.background_blend_mode,
      deviceType = _ref.deviceType,
      eshopType = _ref.eshopType,
      _ref$content = _ref.content,
      title = _ref$content.title,
      linkText = _ref$content.link_text,
      align = _ref$content.align,
      showTitle = _ref$content.show_title,
      showLinkText = _ref$content.show_link_text,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      newBgColor = _ref.background_color,
      textColor = _ref.text_color,
      transparency = _ref.transparency,
      images = _ref.images,
      hasNewStyles = _ref.hasNewStyles;
    var mobileSource = images.mobile.source,
      desktopSource = images.desktop.source;
    var isMobile = deviceType === 'mobile';
    var getImage = function getImage(mobileImage, desktopImage) {
      return isMobile ? mobileImage : desktopImage;
    };
    var img = getImage(mobileSource, desktopSource) || getImage(bgMobile, bgDesktop);
    var contentClass = classnames('banner-text__content', "banner-text__content--".concat(align));
    var bannerTitleClass = classnames('banner-text__title', "banner-text__title--".concat(deviceType), {
      'banner-text__title--desktop-size-weight': hasNewStyles && typeEshop(eshopType) && !isMobile
    });
    var bannerLinkClass = classnames('banner-text__link', "banner-text__link--".concat(deviceType));
    var bannerTextClass = classnames('banner-text-img', {
      'banner-text-img--no-pointer': !(link !== null && link !== void 0 && link.url),
      'banner-text-img--without-opacity': showTitle === false || !title
    });
    var aspectRatio = "".concat(ASPECT_RATIOS_BY_SIZE[deviceType][size]);
    var requiredImageSize = isMobile ? MAX_IMAGE_SIZE_BY_DEVICE.MOBILE : MAX_IMAGE_SIZE_BY_DEVICE.DESKTOP;
    var bannerOpacity = parseFloat(1 - transparency / 100).toFixed(2);
    return /*#__PURE__*/_createRawReactElement(BannerWrapper$1, {
      className: bannerTextClass,
      link: link
    }, void 0, /*#__PURE__*/_createRawReactElement("div", {
      className: "banner-text",
      style: {
        backgroundPosition: backgroundPosition,
        backgroundBlendMode: backgroundBlendMode || BACKGROUND_BLEND_MODE.NORMAL,
        aspectRatio: aspectRatio
      },
      role: "banner"
    }, void 0, (showTitle || showLinkText) && /*#__PURE__*/_createRawReactElement("div", {
      style: {
        backgroundColor: typeEshop(eshopType) && hasNewStyles ? newBgColor : bgColor,
        position: "absolute",
        width: "100%",
        height: "100%",
        zIndex: 1,
        opacity: typeEshop(eshopType) && hasNewStyles && bannerOpacity
      },
      className: "banner__overlay"
    }), /*#__PURE__*/_createRawReactElement(Image, {
      src: validateAndConvertImageUrl(img, requiredImageSize),
      alt: title,
      className: "banner__image"
    }), /*#__PURE__*/_createRawReactElement(Card, {
      className: "banner-card andes-card--animated"
    }, void 0, /*#__PURE__*/_createRawReactElement("div", {
      className: contentClass
    }, void 0, showTitle && /*#__PURE__*/React.createElement("p", _extends({
      className: bannerTitleClass
    }, typeEshop(eshopType) && hasNewStyles && {
      style: {
        color: textColor
      }
    }), title), showLinkText && /*#__PURE__*/_createRawReactElement("p", {
      className: bannerLinkClass
    }, void 0, linkText)))));
  };
  SecondaryBanner.defaultProps = {
    content: {}
  };
  return SecondaryBanner;
}();
var SecondaryBanner$1 = SecondaryBanner;
export { SecondaryBanner$1 as SecondaryBanner, SecondaryBanner$1 as default };
